import React, {Fragment, useState} from "react";
import {Card, CardHeader, CardTitle, Col, Table} from "reactstrap";
import {FaSliders} from "react-icons/fa6";
import Popover from "../../../../components/Popover";
import PopoverItem from "../../../../components/Popover/PopoverItem";
import ProtectedContent from "../../../../components/protectedContent";
import AquaticProfileModal from "./aquaticProfileModal";
import {TYPE_LABELS} from "./constants";

const AquaticProfileCard = ({profile}) => {
  const [isOpen, setOpen] = useState(false);
  const {capacity, design_flow_rate, group_name, minimum_flow_rate, surface_area, type} =
    profile;

  const data = [
    {
      id: "capacity",
      label: "Capacity",
      unit: "gal",
      value: capacity,
    },
    {
      id: "type",
      label: "Type",
      value: TYPE_LABELS[type],
    },
    {
      id: "design_flow_rate",
      label: "Design Flow Rate",
      unit: "GPM",
      value: design_flow_rate,
    },
    {
      id: "minimum_flow_rate",
      label: "Minimum Flow Rate",
      unit: "GPM",
      value: minimum_flow_rate,
    },
    {
      id: "surface_area",
      label: "Surface Area",
      unit: "sq ft",
      value: surface_area,
    },
  ];
  return (
    <Fragment>
      {isOpen && (
        <AquaticProfileModal
          onClose={() => setOpen(false)}
          open={isOpen}
          profile={profile}
        />
      )}
      <Col xs={12} sm={12} md={6} lg={4} style={{marginBottom: "10px"}}>
        <Card outline body data-cy={"aquatic-profile-card"}>
          <CardHeader
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              padding: "0rem 1.25rem",
            }}
          >
            <CardTitle className="card-title">
              <h3>{group_name}</h3>
            </CardTitle>
            <ProtectedContent
              perms={["add_aquaticgroupprofile", "change_aquaticgroupprofile"]}
            >
              <div style={{marginRight: "10px"}}>
                <Popover>
                  <PopoverItem
                    icon={FaSliders}
                    label={"Configure"}
                    onContentSelection={() => setOpen(true)}
                  />
                </Popover>
              </div>
            </ProtectedContent>
          </CardHeader>
          <Table className="card-body">
            {data.map((item, index) => (
              <tr key={index}>
                <td
                  key={index}
                  style={{
                    paddingLeft: "0px",
                    paddingRight: "0px",
                    borderTop: "0px",
                  }}
                >
                  {item.label}
                </td>
                <td
                  data-cy={item.id}
                  style={{
                    paddingLeft: "0px",
                    paddingRight: "0px",
                    borderTop: "0px",
                  }}
                >
                  {item.value ? `${item.value} ${item.unit || ""}` : "-"}
                </td>
              </tr>
            ))}
          </Table>
        </Card>
      </Col>
    </Fragment>
  );
};

export default AquaticProfileCard;
